module.exports = __webpack_public_path__ + "static/alexander_rothman-0fae155eabb133e2025558c22b07b7a5.jpg";